import { render, staticRenderFns } from "./JasaBorongan.vue?vue&type=template&id=7c8dfe18&scoped=true"
import script from "./JasaBorongan.vue?vue&type=script&lang=js"
export * from "./JasaBorongan.vue?vue&type=script&lang=js"
import style0 from "./JasaBorongan.vue?vue&type=style&index=0&id=7c8dfe18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8dfe18",
  null
  
)

export default component.exports